import React from "react";
//#region types
import { ErrorMessageProps } from "models/propTypes/errorMessagePropTypes";
//#endregion
import cssExports from "theme/styles/main.module.scss";
import { Grid } from "@mui/material";
import clsx from "clsx";

const ErrorMessage: React.FC<ErrorMessageProps> = (props) => {
  return (
    <Grid item container className={clsx(cssExports.errorMessage, props.className)} direction="column">
      <Grid item>{props.errorMessage}</Grid>
    </Grid>
  );
};

export default ErrorMessage;
